import React, { useState } from 'react';
import SelectSearch from 'react-select-search';
import 'react-select-search/style.css'; // Import default styles

const SearchableDropdown = ({ options, onChange, placeholder, disabled}) => {
  const [value, setValue] = useState('');

  const handleChange = (selectedValue) => {
    setValue(selectedValue);
    onChange(selectedValue);
  };

  return (
    <div className="searchable-dropdown">
      <SelectSearch
        options={options}
        search
        value={value}
        onChange={handleChange}
        placeholder={!value ? placeholder : ''}
        disabled={disabled}
     />
    </div>
  );
};

export default SearchableDropdown;